import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";

// Alt Bileşenler
import FinansIstatistikleri from "./walletStats";
import FinansGrafik from "./walletOverView";
import SonIslemler from "./walletActivities";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const SistemFinans = () => {
  document.title = "Sistem Finans Özeti | HarmanaGEL Admin";

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.HESAP_TURU === 'Admin';

  const [isLoading, setIsLoading] = useState(true);
  const [stats, setStats] = useState({
    totalRevenue: 0,
    pendingPayments: 0,
    completedCount: 0,
    pendingCount: 0,
    cancelledCount: 0,
    odemeTipleri: {},
    walletHistory: [],
    monthlyData: Array(12).fill(0)
  });

  // ODEME_DURUMU değerlerini normalize et — DB'deki farklı yazım biçimlerini yakala
  const normalizeStatus = (durum) => {
    if (!durum) return "belirsiz";
    const d = durum.toLowerCase().replace(/\s/g, "");
    if (d.includes("tamamlan") || d.includes("complet") || d === "odendi" || d === "ödendi") return "tamamlandi";
    if (d.includes("bekle") || d.includes("pending") || d.includes("wait")) return "beklemede";
    if (d.includes("iptal") || d.includes("cancel") || d.includes("red")) return "iptal";
    return "diger";
  };

  useEffect(() => {
    const fetchSystemStats = async () => {
      setIsLoading(true);
      try {
        if (!isAdmin) {
          toast.error("Bu sayfayı görüntüleme yetkiniz yok.");
          return;
        }

        // Nested expand yerine düz ODEME çekiyoruz — nested expand API'de çalışmıyor olabilir
        const response = await fetch(`${BASE_URL}/ODEME?$top=1000&$orderby=ID desc`);
        const result = await response.json();

        let totalRev = 0;
        let pendingPayments = 0;
        let completedCount = 0;
        let pendingCount = 0;
        let cancelledCount = 0;
        let history = [];
        const monthlyData = Array(12).fill(0);
        const odemeTipleri = {};

        if (result && result.value) {
          // DB'deki gerçek status değerlerini konsolda göster
          const uniqueStatuses = [...new Set(result.value.map(i => i.ODEME_DURUMU))];
          console.log("[Finans] Toplam kayıt:", result.value.length, "| Benzersiz ODEME_DURUMU:", uniqueStatuses);

          result.value.forEach(item => {
            const tutar = parseFloat(item.ODEME_MIKTARI || 0);
            const durumRaw = item.ODEME_DURUMU || "";
            const durumNorm = normalizeStatus(durumRaw);
            const tip = item.ODEME_TIP || item.ODEME_TIPI || "Diğer";

            // Ödeme tipine göre gruplama
            if (!odemeTipleri[tip]) odemeTipleri[tip] = 0;
            odemeTipleri[tip] += tutar;

            if (durumNorm === "tamamlandi") {
              totalRev += tutar;
              completedCount += 1;
              if (item.ODEME_TARIHI) {
                const month = new Date(item.ODEME_TARIHI).getMonth();
                monthlyData[month] += tutar;
              }
            } else if (durumNorm === "beklemede") {
              pendingPayments += tutar;
              pendingCount += 1;
            } else if (durumNorm === "iptal") {
              cancelledCount += 1;
            }

            history.push({
              idno: `ODM-${item.ID}`,
              date: item.ODEME_TARIHI || null,
              type: durumNorm === "tamamlandi" ? "Gelir" : "Gider",
              user: item.SIPARIS_ID ? `Sipariş #${item.SIPARIS_ID}` : "---",
              amount: tutar,
              status: durumRaw || "Belirsiz"
            });
          });
        }

        setStats({
          totalRevenue: totalRev,
          pendingPayments,
          completedCount,
          pendingCount,
          cancelledCount,
          odemeTipleri,
          walletHistory: history,
          monthlyData
        });

      } catch (error) {
        console.error("Finans verisi hatası:", error);
        toast.error("Veriler yüklenirken hata oluştu.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchSystemStats();
  }, [isAdmin]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Finans" breadcrumbItem="Sistem Özeti" />

          {isLoading ? <div className="text-center py-5"><Spinner color="primary"/></div> : (
            <>
              <Row>
                <Col xl="4">
                  <FinansIstatistikleri stats={stats} user={authUser} />
                </Col>

                <Col xl="8">
                  <Row>
                    <Col sm="4">
                      <Card className="mini-stats-wid shadow-sm border-0">
                        <CardBody>
                          <div className="d-flex">
                            <div className="me-3 align-self-center">
                              <i className="mdi mdi-cash-multiple h2 text-success mb-0" />
                            </div>
                            <div className="flex-grow-1">
                              <p className="text-muted mb-2">Toplam Sistem Cirosu</p>
                              <h5 className="mb-0">{stats.totalRevenue.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</h5>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col sm="4">
                      <Card className="mini-stats-wid shadow-sm border-0">
                        <CardBody>
                          <div className="d-flex">
                            <div className="me-3 align-self-center">
                              <i className="mdi mdi-clock-outline h2 text-warning mb-0" />
                            </div>
                            <div className="flex-grow-1">
                              <p className="text-muted mb-2">Bekleyen Ödemeler</p>
                              <h5 className="mb-0">{stats.pendingPayments.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</h5>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col sm="4">
                      <Card className="mini-stats-wid shadow-sm border-0">
                        <CardBody>
                          <div className="d-flex">
                            <div className="me-3 align-self-center">
                              <i className="mdi mdi-check-circle-outline h2 text-primary mb-0" />
                            </div>
                            <div className="flex-grow-1">
                              <p className="text-muted mb-2">Tamamlanan İşlem</p>
                              <h5 className="mb-0">{stats.completedCount} Adet</h5>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  <FinansGrafik monthlyData={stats.monthlyData} />
                </Col>
              </Row>

              <Row>
                <Col lg="12">
                  <SonIslemler history={stats.walletHistory} />
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>
      <ToastContainer autoClose={2000} />
    </React.Fragment>
  );
};

export default SistemFinans;
